import { render } from "./NameForm.vue?vue&type=template&id=57b4db5f"
import script from "./NameForm.vue?vue&type=script&lang=js"
export * from "./NameForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__